import { useEffect, useRef, useState } from "react";
import Header from "../components/headerfull";
import { FooterMaximized } from "../components/footerfull";

import checkCircle from "../assets/svg/check_circle.svg";
import arrowRight from "../assets/svg/arrow_right_alt.svg";
import { RoundBluePlain, RoundGreyPlain, RoundWhitePlain } from "../components/ui/Buttons/generic/GenericButton";
import { OurValue } from "./about-us";
import WorldMapStats from "./parts/WolrdMapsStats";
import UniversitiesSlider from "../components/universitySlider/UniversitiesSlider";
import '../styles/additional.css';

import { CarouselProvider, Slider, Slide/*, ButtonBack, ButtonNext*/ } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import CategoriesSlider from "../components/categorySlider/CategorySlider";
import { Link, useNavigate } from "react-router-dom";
import useWindowSize from "../hooks/useWindowSize";
import ActionSlider from "../components/actionSlider/ActionSlider";

import CATEGS from "../assets/categs.json";

import FreelanceCard, { FreelanceCardLoading } from "components/cards/FreelanceCard";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { _getFreelances } from "services/parcours/freelance.service";

gsap.registerPlugin(ScrollTrigger);

const UNIS= [
    {
        "country": "Afrique du Sud",
        "name": "Université de Cape Town",
        "image_name": "Capetown.svg",
        "image_type": "svg"
    },
    {
        "country": "Inde",
        "name": "Indian Institute of Technology",
        "image_name": "Bombay.svg",
        "image_type": "svg"
    },
    {
        "country": "Madagascar",
        "name": "Université de Fianarantsoa",
        "image_name": "Fianar.png",
        "image_type": "png"
    },
    {
        "country": "Afrique du Sud",
        "name": "Université de Witwatersrand",
        "image_name": "Witwatersrand.png",
        "image_type": "png"
    },
    {
        "country": "Madagascar",
        "name": "Faculté EGS Antananarivo",
        "image_name": "EGS.png",
        "image_type": "png"
    },
    {
        "country": "Nigéria",
        "name": "Université d'Ibadan",
        "image_name": "Ibadan.png",
        "image_type": "png"
    },
    {
        "country": "Nigéria",
        "name": "Université de Lagos",
        "image_name": "Lagos.svg",
        "image_type": "svg"
    },
    {
        "country": "Maroc",
        "name": "Université Mohammed V",
        "image_name": "Mohammed.png",
        "image_type": "png"
    },
    {
        "country": "Ouganda",
        "name": "Université de Makerere",
        "image_name": "Makerere.png",
        "image_type": "png"
    },
    {
        "country": "Sénégal",
        "name": "Université Cheikh Anta Diop (UCAD)",
        "image_name": "UCAD.png",
        "image_type": "png"
    },
    {
        "country": "Inde",
        "name": "Université de Delhi",
        "image_name": "Delhi.png",
        "image_type": "png"
    }
];


export default function Acceuil(){

    useEffect(()=> {
        document.title= "Plateforme freelance innovante - Wall of Share";
        const desc= "Rejoignez Wall of Share, la plateforme innovante qui connecte entreprises et freelances pour des collaborations efficaces et flexibles.";
        setDescription(desc);
    }, []);

    useGSAP(()=>{
        gsap.from('.fade-in', {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.fade-in',
                start: 'top 80%',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
        gsap.from('.fade-in-2', {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.fade-in-2',
                start: 'top 90%',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });

        
        gsap.from('.fade-slide', {
            opacity: 0,
            x: 80,
            duration: .7,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.fade-slide',
                start: 'top 80%',
                end: 'bottom 20%',
                scrub: false,
                toggleActions: 'play none play reverse'
            },
        });
        gsap.from('.fade-slider', {
            opacity: 0,
            x: 80,
            duration: .7,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.fade-slider',
                start: 'top 80%',
                end: 'bottom 20%',
                scrub: false,
                toggleActions: 'play none play reverse'
            },
        });
    }, []);

    return (<>
    <div className="w-full max-w-[100vw] overflow-x-clip">

        <Header type="default"/>

        <HeroBanner />

        <div className="w-full m-0 p-0 lg:hidden">
            <ActionSlider />
        </div>
        <div className="w-full m-0 p-0 hidden lg:block">
            <ActionKindaSlider />
        </div>

        <CommentCa />

        <div className="w-full margin-0 py-[7rem] mt-[15rem]">
            <FreelanceShowCase />
        </div>

        <CategSliderContainer title="Un large panel de domaines et métiers représentés" bg="#f4f4f5"/>

        <div className="w-full margin-0 py-[131.57px] pb-[152.5px]">
            <OurValue />
        </div>

        <WorldMapStats />

        <UniversitiesSlider UNIS={UNIS} />
        <div className="w-full flex items-center justify-center py-0 mt-[1rem] mb-[104px]">
            <RoundWhitePlain text="Découvrez nos freelances" isButton={false} to={"/plateforme-freelance"} className="px-[27px] py-[13.5px] text-[18px] leading-[23px]"/>
        </div>

        <div className="w-full py-[108px] bg-[#f4f4f5]">
            <div className="flex flex-col justify-center items-center gap-[30px] lg:w-3/5 md:w-2/3 w-5/6 mx-auto">
                <div className="font-semibold text-h2 text-primary-blue">Contactez-nous</div>
                <p className="text-center text-[#6F6F6F] font-medium text-xl font-dm-sans">Pour toute question ou pour en savoir plus sur Wall Of Share, <br className="hidden lg:inline"/>n'hésitez pas à nous contacter. Nous sommes là pour vous aider</p>
                <RoundGreyPlain text="Nous contacter" isButton={false} to={"/contactez-nous"} className="px-[27px] py-[13.5px] text-[18px] leading-[23px]" />
            </div>
        </div>

        <FooterMaximized/>
    </div>
    </>);
}

export const CategSliderContainer = ({title, bg, small= true}: {title: string, bg: string, small?: boolean}) => {
    return<>
        <div className={"w-full py-[160px] bg-[" + bg + "]"}>
            <div className="flex flex-col gap-4 w-4/5 mx-auto max-w-[1144px]">
                <h2 className={small ? "md:text-h2 lg:text-[40px] md:text-[36px] text-[30px] lg:leading-[48px] md:leading-[40px] leading-[35px] text-primary-blue font-semibold w-full max-w-[570px]" : "md:text-h2 lg:text-[40px] md:text-[36px] text-[30px] lg:leading-[48px] md:leading-[40px] leading-[35px] text-primary-blue font-semibold w-full"}>{title}</h2>
                <div className="flex lg:flex-row flex-col items-end gap-4 justify-between">
                    <p className="text-[#6F6F6F] font-normal font-dm-sans text-[22px] leading-[28.64px] lg:w-[65%]">Explorez une gamme complète de services spécialisés, adaptés à vos besoins et réalisés par des experts qualifiés</p>
                    <div className="hidden md:block">
                        {
                            bg==="#fff" ?
                            <RoundWhitePlain text="Voir toutes nos catégories" isButton={false} to={"/prestations-entreprises"} className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />
                            :
                            <RoundGreyPlain text="Voir toutes nos catégories" isButton={false} to={"/prestations-entreprises"} className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />

                        }
                    </div>
                </div>
            </div>

            <CategoriesSlider CATEGS={CATEGS} CategoryCard={CategoryCard}/>

            <div className="w-4/5 mx-auto md:hidden mt-[2rem]">
                <RoundGreyPlain text="Voir toutes nos catégories" isButton={false} to={"/prestations-entreprises"} className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />
            </div>


        </div>
    </>;
};

export const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
};

const HeroBanner= () => {
    return <>
        <div id="hero-banner" className="w-full bg-primary-blue h-[800px] relative overflow-hidden bg-cover bg-center" style={{backgroundImage: `url('/acceuil-images/accueil-banner.webp')`}}>
            {/* <img src="/acceuil-images/accueil-banner.webp" alt="" className="object-cover w-full h-auto"/> */}
            <div className="absolute top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%] flex flex-col items-center max-w-[915px] w-5/6 gap-[42px]">
                <h1 id="title" className="text-white font-semibold lg:text-[60px] lg:leading-[72px] md:text-[40px] md:leading-[51px] text-[30px] leading-[36px] text-center fade-in">Transformez votre recrutement avec des <span className='text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 border-2 border-transparent p-[2px]'>talents d'exception</span></h1>
                <p className="text-[25px] leading-[32.55px] text-[#f4f4f5] text-center font-dm-sans fade-in">Connectez-vous avec les meilleurs professionnels du monde entier pour faire croître votre entreprise avec efficacité et confiance.</p>
                <div className="flex lg:flex-row flex-col gap-[10px]">
                    <div className="rounded-[10px] bg-[#424263aa] flex flex-row md:w-[320px] w-[300px] h-[54px] items-center justify-center gap-2 fade-slider">
                        <img src={checkCircle} alt="check" />
                        <span className="font-semibold text-white text-[1.15rem]">Recrutement simplifié</span>
                    </div>
                    <div className="rounded-[10px] bg-[#424263aa] flex flex-row md:w-[320px] w-[300px] h-[54px] items-center justify-center gap-2 fade-slider">
                        <img src={checkCircle} alt="check" />
                        <span className="font-semibold text-white text-[1.15rem]">Talents internationaux</span>
                    </div>
                    <div className="rounded-[10px] bg-[#424263aa] flex flex-row md:w-[320px] w-[300px] h-[54px] items-center justify-center gap-2 fade-slider">
                        <img src={checkCircle} alt="check" />
                        <span className="font-semibold text-white text-[1.15rem]">Paiements Sécurisés</span>
                    </div>
                </div>
                <div className="w-full fade-in flex items-center justify-center">
                    <RoundBluePlain isButton="false" to={"/inscription-entreprises"} text="Démarrez votre projet" className="px-[38px] py-[14.5px] text-[25px] leading-[32.55px]"/>
                </div>
            </div>
        </div>
    </>;
};

const CommentCa= () => {
    useGSAP(() => {
        gsap.from('.fade-up', {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.fade-up-trigger',
                start: 'top 80%',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
    }, []);
    const type= "non-default";
    return (<div className={`${type === 'non-default' ? 'bg-[#F4F4F5]' : ''}  py-[140px] relative pb-[20rem]`}>
        <div className='lg:w-[76%] lg:px-0 px-8 mx-auto max-w-[1152px] lg:min-w-[1000px]'>
            <CommentCaEnTete type={type} />
            <CommentCaSteps type={type} />
        </div>
        <div className="lg:w-3/4 md:w-5/6 w-[92%] max-w-[1144px] bg-[#1D1D39] py-16 md:px-[6rem] px-[1.8em] rounded-3xl absolute bottom-0 left-[50%] transform translate-x-[-50%] translate-y-[50%] flex flex-col justify-center items-center gap-[1.5em] text-center fade-up-trigger">
            <div className="text-h2 text-white text-center lg:w-[73%] md:w-4/5 w-full font-semibold max-md:text-[25px] max-md:leading-[30px] fade-up">7 jours sans engagement pour confirmer votre freelance idéal</div>
            <p className="text-[#BBBBC4cc] font-medium md:text-xl text-[16px] leading-[19px] mb-[15px] fade-up">Lancez votre projet en toute confiance : travaillez avec un freelance sélectionné et évaluez sa compatibilité avec vos besoins. Besoin de changer ? C’est gratuit dans les 7 premiers jours.</p>
            <div className="w-full fade-up">
                <RoundBluePlain text="Commencez votre projet dès maintenant" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" isButton={false} to={"/parcours-entreprise"} />
            </div>
            <img src="/images/flyer.png" alt="flyer" className="w-[13rem] absolute right-0 z-20 top-[50%] transform translate-y-[-50%] hidden md:block"/>
        </div>
    </div>);
};

export const CommentCaEnTete= ({type}: any) => {
    return (<>
        <div className=' text-center text-primary-blue font-bold text-4xl mb-[.7em]'>
            <div>Comment ça marche ?</div>
        </div>

        <div className='text-[#6F6F6F] text-center font-medium my-[1rem] text-xl lg:w-4/5 mx-auto'>
            {
                type === 'non-default' ?
                    (
                        <>Découvrez un processus simple et rapide pour trouver les meilleurs talents et gérer vos projets en toute sérénité, de la publication de votre mission à sa réalisation.</>
                    ) :
                    (
                        <div>Suivez ces étapes simples pour maximiser vos opportunités et accéder à des missions <br /> de qualité avec Wall-of-Share.</div>
                    )
            }
        </div>
    </>
    );
};

export const CommentCaSteps= ({type}: any) => {

    return (
        <>
            <div className='lg:grid grid-cols-3 space-y-8 lg:space-y-0 gap-x-6 mt-8 flex flex-col items-center'>
                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full fade-slide l-fade-x`}>
                    <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max fade-in'>O1</div>
                    <div className='font-bold text-primary-blue text-xl fade-in'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Créez votre compte et publiez votre mission rapidement</>
                                ) : (
                                    <>Créez votre compte et démarquez-vous avec un profil complet</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-medium my-5 fade-in'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Un processus d'inscription simplifié pour vous permettre de publier votre première mission en quelques minutes seulement.</>
                                ) : (
                                    <>Un profil soigné et complet augmente vos chances d'être sélectionné pour des projets de qualité. Inscrivez-vous et attirez les entreprises qui recherchent vos compétences.</>
                                )
                        }
                    </div>
                </div>

                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full fade-slide l-fade-x`}>
                    <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max fade-in'>O2</div>
                    <div className='font-bold text-primary-blue text-xl fade-in'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Accédez à des freelances qualifiés en un temps record</>
                                ) : (
                                    <>Découvrez des missions de qualité avec des entreprises sérieuses</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-medium my-5 fade-in'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Explorez une sélection de freelances triés sur le volet, correspondant parfaitement à vos besoins. Consultez les profils, évaluez les compétences et choisissez vos talents idéaux pour démarrer sans attendre.</>
                                ) : (
                                    <>Accédez à des projets soigneusement vérifiés et proposés par des entreprises sérieuses qui valorisent votre expertise et sont prêtes à payer le juste prix pour des résultats exceptionnels.</>
                                )
                        }

                    </div>
                </div>

                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full fade-slide l-fade-x`}>
                    <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max fade-in'>O3</div>
                    <div className='font-bold text-primary-blue text-xl fade-in'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Suivi de projet simplifié avec gestion automatisée</>
                                ) : (
                                    <>Développez votre carrière avec des opportunités exclusives </>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-medium my-5 fade-in'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Gestion de contrats, paiements sécurisés et suivi de mission – tout est géré sur notre plateforme pour vous garantir une expérience fluide.</>
                                ) : (
                                    <>Accédez à des projets variés et de haute qualité qui vous permettent de renforcer vos compétences et de bâtir une solide réputation.</>
                                )
                        }

                    </div>
                </div>
            </div>
        </>
    );
};

export const CategoryCard= ({bgIm="", title="", desc="", url="#"}: any) => {
    const categLink= useRef<HTMLAnchorElement>(null);

    const [initialMousePos, setInitialMousePos]= useState<{x: number, y: number}>({x: 0, y: 0});
    const [isDragging, setIsDragging]= useState(false);

    const handleMouseDown= (event: any) => {
        setInitialMousePos({x: event.clientX, y: event.clientY});
        setIsDragging(false);
    };
    const handleMouseMove= (event: any) => {
        if(((event.clientX - initialMousePos.x)*(event.clientX - initialMousePos.x) + (event.clientY - initialMousePos.y)*(event.clientY - initialMousePos.y))>25){
            setIsDragging(true);
        }
    };
    const handleMouseUp= (event: any) => {
        if(!isDragging){
            goToCateg();
        }
    };

    const goToCateg= () => {
        if(categLink.current){
            categLink.current.click();
        }
    };
    return (<>
        <div className="w-[285px] bg-primary-blue rounded-2xl h-[470px] flex flex-col justify-end align-center px-[1.5rem] py-[1.7rem] relative overflow-hidden categ card body" style={{ backgroundImage: `url('${bgIm}')`}} data-target-url={url} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseMove={handleMouseMove}>
            <Link to={url} className="hidden" ref={categLink}></Link>
            <div className="flex flex-col realtive z-[3]">
                <div className="text-[30px] leading-[36px] text-white font-semibold">{title}</div>
                <div className="text-[16px] leading-[20.83px] font-dm-sans text-[#bbbbc4cc] font-normal">
                    {desc}
                </div>
                <div>
                    <Link to={url} className="flex justify-end pt-[.5em]">
                        <img src={arrowRight} alt="arrow alt left" className="" />
                    </Link>
                </div>
            </div>
            <div className="absolute top-0 bottom-0 left-0 right-0 z-[2] categ-card-overlay" style={{}}></div>
        </div>
    </>);
};

const ActionKindaSlider= ()=> {//<- When the screen is big enough, the slider is not needed and this appears instead
    return (<>
        <div className="w-full py-[180px]">
            <div className="lg:w-4/5 lg:min-w-[900px] w-[90%] mx-auto flex flex-row gap-8 max-w-[1144px]">
                <div className="bg-primary-blue rounded-[2.5rem] py-[4rem] px-[3rem] w-full flex flex-col gap-[30px] fade-in-2">
                    <div className="w-full h-[13rem] overflow-hidden rounded-2xl bg-cover bg-center bg-norepeat" style={{backgroundImage: `url('/about-images/about-03.webp')`}}>
                    </div>
                    <div className="w-full flex flex-col gap-3 mt-[50px]">
                        <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-3xl font-semibold">Vous êtes une entreprise ?</div>
                        <h2 className="text-[35px] leading-[42px] text-white font-semibold fade-in">Confiez votre projet à Wall of Share !</h2>
                        <p className="text-[#BBBBC4cc] font-normal md:text-[20px] md:leading-[26.04px] text-[16px] leading-[19px] fade-in-2">Avec Wall of Share, rencontrez le talent qui correspond exactement à votre besoin. Simplifiez votre processus de recrutement et accédez rapidement à des experts prêts à relever vos défis.</p>
                    </div>
                    <div className="w-full fade-in-2">
                        <RoundBluePlain text="Inscrivez-vous" isButton={false} to={"/inscription-entreprises"} className="px-[2rem] py-[1rem] font-semibold text-[18px] leading-[23.44px]" />
                    </div>
                </div>
                <div className="bg-[#F4F4F5] rounded-[2.5rem] py-[4rem] px-[3rem] w-full flex flex-col gap-[30px] fade-in-2">
                    <div className="w-full h-[13rem] overflow-hidden rounded-2xl bg-cover bg-center bg-norepeat" style={{backgroundImage: `url('/acceuil-images/action-02.webp')`}}>
                    </div>
                    <div className="w-full flex flex-col gap-3 mt-[50px]">
                        <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-3xl font-semibold">Vous êtes un freelance ?</div>
                        <h2 className="text-[35px] leading-[42px] text-primary-blue font-semibold fade-in-2">Mettez en valeur vos compétences !</h2>
                        <p className="text-[#6F6F6F] font-normal md:text-[20px] md:leading-[26.04px] text-[16px] leading-[19px] fade-in-2">Rejoignez une communauté d'experts et accédez à des projets qui correspondent à vos compétences. Avec Wall of Share, valorisez votre expertise et trouvez des missions qui vous stimulent.</p>
                    </div>
                    <div className="w-full fade-in-2">
                        <RoundGreyPlain text="Inscrivez-vous" isButton={false} to={"/inscription-freelances"} className="px-[2rem] py-[1rem] font-semibold text-[18px] leading-[23.44px]" />
                    </div>
                </div>
            </div>
        </div>
    </>);
};

const FreelanceShowCase= () => {
    const [freels, setFreels]= useState([]);
    const [freelsLoading, setFreelsLoading]= useState(true);

    const spaceBetweenSlides= 50;
    const slideSizesInX= 324;
    const w= useWindowSize();
    const [carouselContainerSize, setCarouselContainerSize]= useState(0);
    
    const carouselContainerRef= useRef<HTMLDivElement>(null);
    
    const [slidesToShow, setSlidesToShow]= useState((carouselContainerSize + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));

    useEffect(()=>{
        /*Fetching a few freelances*/
        (async function() {

            let response= await _getFreelances("?page_size=40");
            console.log(response);
            setFreels(response.data);
        })();
        /*Fetching a few freelances END*/
        const windowResizeHandler= () =>{
            if(carouselContainerRef.current){
                setCarouselContainerSize(carouselContainerRef.current.offsetWidth);
            }
        };
        window.addEventListener("resize", windowResizeHandler);
        window.dispatchEvent(new Event("resize"));//<- This has to be here otherwise the logic breaks because slidesToShow is calculated when carouselContainerSize is 0 and is never updated afterwards. So manually firing the resize event forces a recalculation with the correct values.
        return ()=> {
            window.removeEventListener("resize", windowResizeHandler);
        };
    },[]);

    useEffect(()=>{
        if (freels.length > 0){
            setFreelsLoading(false);
        } else {
            setFreelsLoading(true);
        }
    }, [freels]);

    useEffect(()=> {
        if(carouselContainerRef.current!== null){
            setSlidesToShow((carouselContainerSize + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
        } else {
            setSlidesToShow((w + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
        }
    },[carouselContainerSize, w]);

    return (<>
        <div className="flex flex-col gap-[50px] items-center">
            <h2 className="text-h2 max-md:text-[25px] max-md:leading-[30px] font-semibold text-center">Découvrez nos <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">freelances</span></h2>
            <div className="w-full overflow-hidden">
                <div className="w-[95%] mx-auto no-clip-slider" ref={carouselContainerRef}>
                    <CarouselProvider  visibleSlides={slidesToShow} totalSlides={freels.length} naturalSlideHeight={470} naturalSlideWidth={285} isIntrinsicHeight={true} step={0.1} >
                        <Slider>
                            {
                                freelsLoading ?
                                [1, 2 ,3, 4, 5, 6, 7, 8, 9, 10].map((el:any, index: number)=>(
                                    <Slide key={"placeholder-" + index} index={index}>
                                        <FreelanceCardLoading isWhite={false}/>
                                    </Slide>
                                ))
                                 :
                                freels.map((el: any, index: number) => (
                                    <Slide key={"freelance-slide-" + index} index={index}>
                                        {/* <FreelanceCard rating={freel.rating} firstname={freel.firstname} lastname={freel.lastname} photo={freel.photo} audioAvailable={freel.audioAvailable} salary={freel.salary} ratersNumber={freel.ratersNumber} skills={freel.skills} online={freel.online} xp={freel.xp} jobTitle={freel.jobTitle}/> */}

                                        <FreelanceCard rating={el?.avg_rating} firstname={el?.name?.split(' ')[0]} lastname={el?.name?.split(' ')?.slice(1)?.join(' ')} photo={el.image_url.image_url_512 ?? el.image_url.image_url_128 ?? el.image_url.image_url_128} audioAvailable={el.audio} salary={el.price_per_month} ratersNumber={el.rate_number} skills={el.competences.map((comp: any)=>comp.name)} online={!el.booked} xp={el?.experience} jobTitle={el?.favorite_domain && el.favorite_domain[0].name} id={el.id} />
                                    </Slide>
                                ))
                            }
                        </Slider>
                    </CarouselProvider>
                </div>
            </div>
            <RoundWhitePlain text="Trouvez un freelance" isButton={false} to={"/plateforme-freelance"} className="py-[13.5px] px-[27px] font-semibold text-[18px] leading-[23.44px]"/>
        </div>
    </>);
};
